"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccessibilityModulesType = void 0;
var AccessibilityModulesType;
exports.AccessibilityModulesType = AccessibilityModulesType;
(function (AccessibilityModulesType) {
  AccessibilityModulesType[AccessibilityModulesType["increaseText"] = 1] = "increaseText";
  AccessibilityModulesType[AccessibilityModulesType["decreaseText"] = 2] = "decreaseText";
  AccessibilityModulesType[AccessibilityModulesType["increaseTextSpacing"] = 3] = "increaseTextSpacing";
  AccessibilityModulesType[AccessibilityModulesType["decreaseTextSpacing"] = 4] = "decreaseTextSpacing";
  AccessibilityModulesType[AccessibilityModulesType["increaseLineHeight"] = 5] = "increaseLineHeight";
  AccessibilityModulesType[AccessibilityModulesType["decreaseLineHeight"] = 6] = "decreaseLineHeight";
  AccessibilityModulesType[AccessibilityModulesType["invertColors"] = 7] = "invertColors";
  AccessibilityModulesType[AccessibilityModulesType["grayHues"] = 8] = "grayHues";
  AccessibilityModulesType[AccessibilityModulesType["bigCursor"] = 9] = "bigCursor";
  AccessibilityModulesType[AccessibilityModulesType["readingGuide"] = 10] = "readingGuide";
  AccessibilityModulesType[AccessibilityModulesType["underlineLinks"] = 11] = "underlineLinks";
  AccessibilityModulesType[AccessibilityModulesType["textToSpeech"] = 12] = "textToSpeech";
  AccessibilityModulesType[AccessibilityModulesType["speechToText"] = 13] = "speechToText";
  AccessibilityModulesType[AccessibilityModulesType["disableAnimations"] = 14] = "disableAnimations";
  AccessibilityModulesType[AccessibilityModulesType["iframeModals"] = 15] = "iframeModals";
  AccessibilityModulesType[AccessibilityModulesType["customFunctions"] = 16] = "customFunctions";
})(AccessibilityModulesType || (exports.AccessibilityModulesType = AccessibilityModulesType = {}));


//////////////////
// WEBPACK FOOTER
// ./~/accessibility/dist/interfaces/accessibility.interface.js
// module id = VCPg
// module chunks = 16